import SvgLib from '@/components/SvgLib'

export default {
  name: 'CreateName',
  template: '#create-name-template',
  data () {
    return {
      name: this.$store.state.teamName,
      tag: this.$store.state.teamTag,
      modalActive: false,
      tagEmpty: false,
      nameEmpty: false,
      tagReset: false,
      nameReset: false
    }
  },
  components: { SvgLib },
  props: ['backRoute'],
  methods: {
    confirmName () {
      if (this.$refs.nameInput.value && this.$refs.tagInput.value && this.nameLength && this.tagLength) {
        this.$store.dispatch('setTeamName', this.name)
        this.$store.dispatch('setTeamTag', this.tag)
        this.$router.push(this.backRoute)
      } else {
        if (this.$refs.nameInput.value && this.nameLength) {
          this.tagEmpty = true
        } else if (this.$refs.tagInput.value && this.tagLength) {
          this.nameEmpty = true
        } else {
          this.tagEmpty = true
          this.nameEmpty = true
        }
      }
    },
    tagOnKeyUp (e) {
      e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z]+/, '').substring(0, 3)
      this.tag = e.currentTarget.value
      if (this.tagEmpty && this.tag.length > 0) this.tagEmpty = false
    },
    nameOnKeyUp (e) {
      e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z 0-9]+/, '').substring(0, 25)
      this.name = e.currentTarget.value
      if (this.nameEmpty && this.name.length > 0) this.nameEmpty = false
    },
    checkRandom (e) {
      if (this.$parent.didRandomize) {
        if (parseInt(e.currentTarget.getAttribute('maxlength')) === 3) {
          if (!this.tagReset) {
            e.currentTarget.value = ''
            this.tag = ''
            this.tagReset = true
          }
        } else {
          if (!this.nameReset) {
            e.currentTarget.value = ''
            this.name = ''
            this.nameReset = true
          }
        }
        if (this.tagReset && this.nameReset) {
          this.$parent.didRandomize = false
        }
      }
    }
  },
  computed: {
    tagLength () {
      return this.tag.length === 3
    },
    nameLength () {
      return this.name.length >= 4
    },
    noNameShadow () {
      return this.name.length === 0
    },
    noTagShadow () {
      return this.tag.length === 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/create/CreateName.js